import { render, staticRenderFns } from "./AddAccounts.vue?vue&type=template&id=8bafe7ce&scoped=true&"
import script from "./AddAccounts.vue?vue&type=script&lang=js&"
export * from "./AddAccounts.vue?vue&type=script&lang=js&"
import style0 from "./AddAccounts.vue?vue&type=style&index=0&id=8bafe7ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bafe7ce",
  null
  
)

export default component.exports